import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IBidDescription } from 'types/bidDescription'

export const bidDescriptionsApi = createApi({
  reducerPath: 'bidDescriptions',
  baseQuery,
  endpoints: (builder) => ({

    bidDescriptions: builder.query<IBidDescription[], void>({
      query: () => ({
        url: '/bid-descriptions',
      }),
    }),

    bidDescription: builder.query<IBidDescription, IdParams>({
      query: ({ id }) => `/bid-descriptions/${id}`,
    }),

    createBidDescription: builder.mutation<
      IBidDescription,
      Partial<IBidDescription>
    >({
      query: (body) => ({
        url: '/bid-descriptions',
        body,
        method: 'post',
      }),
    }),
    
    updateBidDescription: builder.mutation<
      IBidDescription,
      Partial<IBidDescription>
    >({
      query: (body) => ({
        url: `/bid-descriptions/${body.id}`,
        body,
        method: 'put',
      }),
    }),
    
    deleteBidDescription: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/bid-descriptions/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useBidDescriptionQuery,
  useBidDescriptionsQuery,
  useCreateBidDescriptionMutation,
  useUpdateBidDescriptionMutation,
  useDeleteBidDescriptionMutation,
} = bidDescriptionsApi
